export const calcWrapperScale = (wrapper: HTMLDivElement) => {
  const horizontalScale =  document.documentElement.clientWidth / wrapper.offsetWidth;
  const verticalScale =  document.documentElement.clientHeight / wrapper.offsetHeight;
  return (verticalScale > horizontalScale) ? verticalScale : horizontalScale;
};